<template>
<div class="product">
    <div id="public-head">
        <img :src="bg" alt srcset />
        <div class="title-box">
            <p class="title">产品中心</p>
            <p class="en-title">PRODUCT CENTER</p>
        </div>
        <div class="list" v-show="list.length>0">
            <div v-for="(item,index) in list_name" :class="{active:index==opt}" @click="check(index)">{{item}}</div>
        </div>
    </div>
    <div class="wrap" v-if="$route.path=='/product'">
        <p class="child-title">{{list[opt].name}}</p>
        <!-- <p class="child-sub-title">{{list[opt].ex_title}}</p> -->
        <ul>
            <router-link tag="li" v-for="(item,index) in productList" :key="index" :to="{path:'/product/detail',query:{id:item.id}}">
                <div class="img-box">
                    <img :src="item.image" alt srcset />
                </div>
                <div class="down">{{item.name}}</div>
            </router-link>
        </ul>
    </div>
    <router-view></router-view>
</div>
</template>

<script>
import {
    classe,
    productList
} from "../assets/js/api";
export default {
    data() {
        return {
            opt: 0,
            list: [],
            list_name: [],
            productList: [],
            bg: require("../assets/img/product-head.png"),
        };
    },
    watch: {
        "$route.query.index": {
            handler(e) {
                if (this.$route.path == "/product") {
                    this.opt = e;
                }
            },
            deep: true,
        },
        opt() {
            this.getData();
        },
        "$route.query.idx": {
            handler(e) {
                if (e) {
                    location.reload();
                }
            },
            deep: true,
        },
    },
    created() {
        this.getclasse();
    },
    methods: {
        check(e) {
            this.$router.push({
                path: "/product",
                query: {
                    idx: this.list[e].id,
                },
            });
        },
        getclasse() {
            classe().then((r) => {
                this.list = r.data.data;
                this.list_name = r.data.data.map((val) => {
                    return val.name;
                });
                let id = this.$route.query.idx || this.$route.query.id;
                if (id) {
                    r.data.data.forEach((val, index) => {
                        if (val.id == id) {
                            this.opt = index;
                        }
                    });
                }
                this.getData();
            });
        },
        getData() {
            productList({
                limit: 9999,
                page: 1,
                where: {
                    classe_id: this.list[this.opt].id,
                },
            }).then((r) => {
                this.productList = r.data.data;
            });
        },
    },
};
</script>

<style lang="less" scoped>
.product {
    background: rgb(246, 246, 246);
    min-height: 100vh;
}

#public-head {
    width: 100%;
    background-repeat: no-repeat;
    background-size: cover;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    position: relative;

    &>img {
        width: 100%;
        height: 3.7rem;
    }

    .title-box {
        position: absolute;
        top: 1.41rem;
        left: 0;
        width: 100%;

        .title {
            font-size: 0.36rem;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #ffffff;
            margin-bottom: 0.24rem;
            text-align: center;
        }

        .en-title {
            font-size: 0.3rem;
            font-family: Source Han Sans CN;
            font-weight: bold;
            color: #ffffff;
            text-align: center;
        }
    }

    .list {
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        position: relative;
        top: -0.37rem;
        background: #ffffff;
        box-shadow: 0px 0px 0.25rem 0px rgba(18, 111, 204, 0.2);
        border-radius: 10px;
        overflow: hidden;

        div {
            line-height: 1.1rem;
            padding: 0 0.4rem;
            font-size: 0.22rem;
            font-weight: 400;
            font-family: Source Han Sans CN;
            transition: all 0.15s linear;
        }

        div.active {
            font-weight: bold;
            color: #ffffff;
            background: #126fcc;
        }
    }
}

.wrap {
    ul {
        margin-top: 0.55rem;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        padding: 0 0.3rem;
        box-sizing: border-box;

        li {
            width: 48%;
            margin-bottom: 0.3rem;
            box-shadow: 0px 0px 9px 0px rgba(0, 0, 0, 0.18);

            .img-box {
                width: 100%;
                background: white;
                padding: 0.3rem 0.67rem;
                box-sizing: border-box;
                height: 2.1rem;

                img {
                    max-width: 100%;
                    max-height: 100%;
                    display: block;
                    margin: 0 auto;
                    object-fit: cover;
                }
            }

            .down {
                line-height: 0.79rem;
                text-align: center;
                font-size: 0.26rem;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #000000;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                padding: 0 0.36rem;
                box-sizing: border-box;
            }
        }
    }
}
</style>
